export const handleImageUpload = async ({
  event,
  index,
  versusSettings,
  setVersusSettings,
  createBlobInContainer,
  setLoading,
}) => {
  const file = event.target.files[0];
  if (!file) return;

  const validTypes = ["image/jpeg", "image/png", "image/webp"];
  const maxSize = 2 * 1024 * 1024;

  if (!validTypes.includes(file.type) || file.size > maxSize) {
    event.target.value = null;
    return;
  }

  setLoading(true);

  try {
    const originalName = file.name;
    const extension = originalName.substring(originalName.lastIndexOf("."));
    const safeFileName = `image_${Date.now()}${extension}`;
    const renamedFile = new File([file], safeFileName, { type: file.type });

    await createBlobInContainer(renamedFile);

    const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
    const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;
    const imageUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${safeFileName}`;

    const newSettings = { ...versusSettings };
    newSettings.gameModes[index].icon = imageUrl;
    setVersusSettings(newSettings);
  } catch (err) {
    throw new Error();
  } finally {
    setLoading(false);
    event.target.value = null;
  }
};
